import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_szmga73tgk: FaireBrandEntity = {
  token: "b_szmga73tgk",
  type: "brand",
  name: "Knuckleheads Clothing",
  avatarUrl:
    "https://cdn.faire.com/fastly/44f418e0aa466e64f4175e397af9ebf4c3880fa934e5d2ac535694f172bc92a1.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1e1f25dc3f6ed803bd2fb1d5f278e72221feab8b945385f6ceeb5a75686add3e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/44f418e0aa466e64f4175e397af9ebf4c3880fa934e5d2ac535694f172bc92a1.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1e1f25dc3f6ed803bd2fb1d5f278e72221feab8b945385f6ceeb5a75686add3e.png",
  location: "San Luis Obispo, CA, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "Knuckleheads began with a simple idea—creating stylish and functional clothing for boys when a new mom couldn’t find cool options for her son. It all started with resizing one of her husband's hats to fit a toddler, sparking interest from everyone who saw it. This led to a business dedicated to crafting trendy hats and clothing for children, with matching styles for dads.\n\nFast forward 18 years, Knuckleheads is a well-loved brand featured in trendy boutiques across the U.S. and even spotted on celebrities. The brand remains focused on unique, dad-approved designs that stand out. Beyond fashion, Knuckleheads is a family-driven venture, with a warehouse in Central California where kids play freely while the team continues to create headwear and apparel that customers can’t get enough of.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:28.764Z",
    importedBy: "entity-db-cli",
  },
};
